<nz-modal nzTitle="Save As" [nzVisible]="visible" [nzOkLoading]="loading" nzOkText="Submit" (nzOnOk)="submit()"
  (nzOnCancel)="visible = false">
  <ng-container *nzModalContent>
    <form nz-form #f="ngForm" nzLayout="vertical">
      <nz-form-item required>
        <nz-form-label>Display Name</nz-form-label>
        <nz-form-control nzErrorTip="Display name is required!">
          <input required nz-input [(ngModel)]="report.displayName" name="displayName" />
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
